import React, { useMemo, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authorize } from "@/redux/ducks/user";
import { ReceiptView } from "./view";
import useTicket from "@/hooks/useTicket";

const ReceiptPage: React.FC = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const [isInitLoading, setIsInitLoading] = useState(true);
    const {
        getInvoice,
        generatePDF,
        invoice,
        isLoading,
        errorInvoice
    } = useTicket();

    const hashParam = useMemo(() => {
        return new URLSearchParams(search).get("q");
    }, [search]);

    useEffect(() => {
        if (hashParam) {
            dispatch(
                authorize({
                    plate: "XXX9999",
                    token: '',
                    callback: () => {
                        getInvoice({
                            id: "hash",
                            hash: hashParam,
                            date: "",
                            price: "",
                            status: ""
                        });
                        setIsInitLoading(false);
                    },
                    isAcceptedTerms: true,
                })
            );
        }
    }, [hashParam, dispatch]);

    const combinedLoading = isInitLoading || isLoading;

    return (
        <ReceiptView
            isLoading={combinedLoading}
            hashParam={hashParam}
            invoice={invoice}
            errorInvoice={errorInvoice}
            generatePDF={generatePDF}
        />
    );
};

export default ReceiptPage;